




import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * 处理省份只显示一个
 */
@Component
export default class ChannelComponents extends Vue {
  @Prop({ default: '' }) private channel: string
  private channelOne: string = ''
  public mounted() {
    this.channelOne = this.channel.split(';')[0]
    if (this.channel.split(';').length > 1) {
      this.channelOne += '....'
    }
  }
}
